import React, { useCallback, useMemo, useState } from 'react';

const useUrlSlug = (
  persistedUrl: string | undefined,
  reservedUrls?: string[],
) => {
  const [urlSlug, setUrlSlug] = useState<string>(
    persistedUrl ? persistedUrl : '',
  );

  const onUrlSlugChanged = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (persistedUrl) {
        return;
      }
      setUrlSlug(event.target.value);
    },
    [persistedUrl],
  );
  const getIsUrlSlugValid = useCallback(
    (testUrlSlug: string) => {
      if (persistedUrl) {
        return true;
      }
      const isReservedUrl =
        !!reservedUrls && reservedUrls.some((url) => url === testUrlSlug);
      const isEmpty = testUrlSlug === '';
      const hasBannedCharacters = /[^0-9a-zA-Z/-]/g.test(testUrlSlug);

      return !(isReservedUrl || isEmpty || hasBannedCharacters);
    },
    [persistedUrl, reservedUrls],
  );

  const isUrlSlugValid = useMemo(() => {
    return getIsUrlSlugValid(urlSlug);
  }, [getIsUrlSlugValid, urlSlug]);

  return {
    urlSlug,
    setUrlSlug,
    onUrlSlugChanged,
    isUrlSlugValid,
    getIsUrlSlugValid,
  };
};

export default useUrlSlug;
